import { render, staticRenderFns } from "./CopyAttachment.vue?vue&type=template&id=313745a3&"
import script from "./CopyAttachment.vue?vue&type=script&lang=js&"
export * from "./CopyAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/pixflow.app/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('313745a3', component.options)
    } else {
      api.reload('313745a3', component.options)
    }
    module.hot.accept("./CopyAttachment.vue?vue&type=template&id=313745a3&", function () {
      api.rerender('313745a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/CopyAttachment.vue"
export default component.exports